export default __webpack_public_path__ + "static/media/horizontal.809e8f32.mp4";